import ResizeObserver from "resize-observer-polyfill";
// import el from "element-ui/src/locale/lang/el";

const curryDataType = str => {
  return data => {
    return Object.prototype.toString.apply(data) === str;
  };
};
export const isArray = curryDataType("[object Array]");
// export const isDate = curryDataType("[object Date]");
export const isReg = curryDataType("[object RegExp]");
export const isNull = curryDataType("[object Null]");
export const isString = curryDataType("[object String]");
export const isNumber = curryDataType("[object Number]");
export const isUndefined = curryDataType("[object Undefined]");
export const isBoolean = curryDataType("[object Boolean]");
export const isFunction = curryDataType("[object Function]");
// TODO 浏览器不支持，返回为Function
export const isAsyncFunction = curryDataType("[object AsyncFunction]");
export const isObject = curryDataType("[object Object]");
export const isValidNumber = x =>
  isNumber(x) && Number.isFinite(x) && !Number.isNaN(x);
export const isValidArray = x => isArray(x) && x.length > 0;
export const isValidLengthArray = x => isArray(x) && x.length >= 0;
export const isDef = x => !isNull(x) && !isUndefined(x);

const merge = function(target, source) {
  if (!target) return;
  for (let key in source) {
    if (isArray(source[key]) || isArray(target[key])) {
      target[key] = source[key];
    } else if (isObject(source[key])) {
      !target[key] && (target[key] = {});
      merge(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
};
const filterOneH = function(Array, step) {
  let endTime = [],
    three = 0,
    two = 0;
  let dealArr = [],
    open = [];
  const arr = deepCopy(Array);
  arr.map(function(item, index) {
    const dealItem = item.replace(/:/gi, "");
    const OpenClose = dealItem.indexOf("/") == -1; //没找到
    if (!OpenClose || index == arr.length - 1) {
      const openTime = Number(1 + dealItem.split("/")[1]);
      const clostTime = Number(1 + dealItem.split("/")[0]);
      const preOpenTime = Number(
        1 + (arr[index - 1].split("/")[1] || arr[index - 1]).replace(/:/gi, "")
      );
      // const afterCloseTime = Number(1 + (arr[index + 1].split('/')[0]||arr[index + 1]).replace(/:/ig,''))
      if (openTime) {
        open.push(openTime);
      }
      const dealItemThree = parseInt(openTime / 100);
      if (openTime % 100 == 15) {
        dealArr.push(dealItemThree == 123 ? 10000 : (dealItemThree + 1) * 100);
      }
      if (preOpenTime > clostTime) {
        const type = preOpenTime % 100;
        for (let i = preOpenTime; i <= 12400; i += step) {
          if (i >= 12400) {
            two = i % 100;
            dealArr.push(10000 + two);
          } else {
            dealArr.push(i);
          }
        }
        for (let i = type == 0 ? 10000 : 10030; i <= clostTime; i += step) {
          dealArr.push(i);
        }
      } else {
        for (let i = preOpenTime; i <= clostTime; i += step) {
          dealArr.push(i);
        }
      }
    } else {
      if (index == 0) {
        open.push(Number(1 + dealItem));
      }
      dealArr.push(Number(1 + dealItem));
    }
  });
  const time = [...new Set(dealArr.slice(1))];
  endTime = time.filter(item => !open.includes(item));
  return endTime;
};
const filterOpen = function({ open, all, range }) {
  //在open里面找到all里面的值，找不到的找时间点比它大一个单位的
  const sortAll = [...new Set([...open, ...all])].sort(function(a, b) {
    return a - b;
  });
  let dealOpen = [],
    valueIndex1 = 0,
    valueIndex2 = 0;
  open.forEach(function(item, index) {
    const dealItem = item.toString().substr(-2);
    const openIndex = sortAll.findIndex(function(intd) {
      return intd == item;
    });
    // if(range == 50){
    //   if(!['30','00'].includes(dealItem)){
    //     //如果是23:30之前的
    //     if(item>12330){
    //       dealOpen.push(sortAll.slice(openIndex,openIndex+1))
    //       dealOpen.push(sortAll.slice(0,1))
    //     }else {
    //       dealOpen.push(sortAll.slice(openIndex,openIndex+2))
    //     }
    //   }else {
    //     dealOpen.push(item)
    //   }
    // }
    const dealItemThree = parseInt(item / 100);
    const dealItemTwo = (item % 100) + 100;
    if (range == 100) {
    } else {
      if (dealItemTwo <= 130) {
        const value = dealItemThree * 100 + (dealItemTwo == 100 ? 0 : 30);
        dealOpen.push(value);
      } else {
        let value1 = null;
        value1 = (dealItemThree == 123 ? 100 : dealItemThree + 1) * 100;
        dealOpen.push(value1);
      }
    }
  });
  // console.log(dealOpen,open)
  return dealOpen;
};
export const formatAxisX = function(Array, interval = 100) {
  let open = [],
    validArr = [],
    openThen = [],
    arr = [];
  const min_X = deepCopy(Array),
    range = interval;
  if (min_X[1].indexOf("/") == -1) {
    //兼容以前的cach里面按照时间点划分的除了开收盘还有其它的时间点
    arr.push(min_X[0]);
    min_X.forEach(function(items, index) {
      const indexM = min_X.findIndex(item => item.indexOf("/") != -1);
      if (indexM != -1 && !arr.includes(min_X[indexM])) {
        arr.push(min_X[indexM]);
      }
    });
    arr.push(min_X[min_X.length - 1]);
  } else {
    //没有明确的时间点，只有开收盘
    arr = min_X;
  }

  const half = [
    10030,
    10130,
    10230,
    10330,
    10430,
    10530,
    10630,
    10730,
    10830,
    10930,
    11030,
    11130,
    11230,
    11330,
    11430,
    11530,
    11630,
    11730,
    11830,
    11930,
    12030,
    12130,
    12230,
    12330
  ];
  const intDot = [
    10100,
    10200,
    10300,
    10400,
    10500,
    10600,
    10700,
    10800,
    10900,
    11000,
    11100,
    11200,
    11300,
    11400,
    11500,
    11600,
    11700,
    11800,
    11900,
    12000,
    12100,
    12200,
    12300,
    10000
  ];
  const all = half.concat(intDot);
  switch (range) {
    case 50:
      arr.forEach(function(item, index) {
        const dealItem = item.replace(/:/gi, "");
        const OpenClose = dealItem.indexOf("/") == -1;
        if (index == 0) {
          open.push(Number(1 + dealItem));
        }
        if (!OpenClose) {
          const beh = Number(1 + dealItem.split("/")[1]); //开盘点
          open.push(beh);
        }
      });
      //这里的open会有非00和30的时间点
      openThen = filterOpen({ open, all, range });
      validArr = all.filter(item => !openThen.includes(item));
      return validArr;
      break;
    case 100:
      validArr = filterOneH(arr, 100);
      return validArr;
      break;
    default:
      // validArr = all.filter(item => !open.includes(item));
      validArr = filterOneH(arr, interval);
      return validArr;
      break;
  }

  return validArr;
};
//过滤对象里面的非空字段
export const getObj = function(objs) {
  var obj = deepCopy(objs);
  Object.keys(obj).forEach(function(key) {
    if (obj[key] === "" || obj[key] == null || obj[key].length === 0) {
      delete obj[key];
    }
  });
  return obj;
};
export const cloneObj = function(obj) {
  var str, newobj = obj.constructor === Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  } else if (window.JSON) {
    str = JSON.stringify(obj), //序列化对象
      newobj = JSON.parse(str); //还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
    }
  }
  return newobj;
}
export const deepCopy = function(target, source) {
  if (!target) return;
  if (isObject(source)) {
    for (let key in source) {
      if (isArray(source[key])) {
        target[key] = [];
        deepCopy(target[key], source[key]);
      } else if (isObject(source[key])) {
        target[key] = {};
        deepCopy(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  } else if (isArray(source)) {
    for (let val of source) {
      let newDestination;
      if (isArray(val)) {
        newDestination = [];
        deepCopy(newDestination, val);
      } else if (isObject(val)) {
        newDestination = {};
        deepCopy(newDestination, val);
      } else {
        newDestination = val;
      }
      target.push(newDestination);
    }
  }
  return target;
};
export const mergeOption = function(target, ...sources) {
  if (!target) return;
  for (let source of sources) {
    merge(target, source);
  }
  return target;
};
export const getIndex = (fields, key) => {
  return fields.findIndex(a => a === key);
};

export const mergeModelData = function(model, data) {
  const { model: modelData = {}, ...rest } = data;
  for (let key in model) {
    const modelVal = model[key];
    if (isObject(modelVal)) {
      // 默认是必需的
      const { Required = true, Default, Type, Deep } = modelVal;
      const newVal = rest[key];
      const oldVal = modelData[key];
      const defNew = isDef(newVal);
      const defOld = isDef(oldVal);
      if (Required&&!defNew) {
        if (!defOld) {
          throw new Error(`data has no ${key} in model`);
        } else {
          continue;
        }
      }
      if (defNew) {
        if (!defOld) {
          const err = isFunction(Type)&&(!(newVal instanceof Type || newVal.constructor === Type))
          if (err) {
            throw new Error(`${key} don\'t match the Type`);
          }
          const isObj = isObject(newVal)
          const isArr = isArray(newVal)
          const newDatas = deepCopy(isObj?{}:isArr?[]:modelData[key], newVal)
          modelData[key] = !Deep?newVal:newDatas;
        }
      } else {
        const isFun = isFunction(Default)
        modelData[key] = isFun?Default():Default;
      }
    }
  }
  return { model: modelData, ...rest };
};
export const bind = function(ele, event, fn, isStopPropagation) {
  if (window.addEventListener) {
    ele.addEventListener(event, fn, !!isStopPropagation);
  } else {
    ele.attachEvent("on" + event, fn, !!isStopPropagation);
  }
};
export const unBind = function(ele, event, fn, isStopPropagation) {
  if (window.removeEventListener) {
    ele.removeEventListener(event, fn, !!isStopPropagation);
  } else {
    ele.detachEvent("on" + event, fn, !!isStopPropagation);
  }
};
export const preventScale = function() {
  bind(
    document,
    "touchstart",
    function(evt) {
      if (evt.touches.length > 1) {
        evt.preventDefault();
      }
    },
    true
  );
  let lastTap = 0;
  bind(
    document,
    "touchend",
    function(evt) {
      const now = new Date().getTime();
      if (now - lastTap <= 300) {
        evt.preventDefault();
      }
      lastTap = now;
    },
    true
  );
};

/**
 * [监听DOM元素大小变化]
 * @param  {Function} fn       [回调函数]
 * @return {[type]}            [description]
 */
export const resizeObserver = fn => {
  return new ResizeObserver(entries => {
    entries.forEach(entry => {
      fn(entry);
    });
  });
};
/**
 *
 */
export const mutationObserver = (function() {
  const MutationObserver =
    window.MutationObserver ||
    window.WebKitMutationObserver ||
    window.MozMutationObserver;
  return fn => {
    return new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        fn(mutation);
      });
    });
  };
})();
/**
 * 格式化数据
 */
export const numberFormat = (number, ratioFixed = 2) => {
  if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
    throw new Error(`${number} or ${ratioFixed} is not a valid number`);
  }
  if (Math.abs(number) > 1000000000000) {
    return (Math.abs(number) / 1000000000000).toFixed(ratioFixed) + "万亿";
  } else if (number > 100000000) {
    return number > 0
      ? (number / 100000000).toFixed(ratioFixed) + "亿"
      : (number / 100000000).toFixed(ratioFixed) + "亿";
  } else if (Math.abs(number) >= 10000) {
    return number > 0
      ? (number / 10000).toFixed(ratioFixed) + "万"
      : (number / 10000).toFixed(ratioFixed) + "万";
  } else {
    return number.toFixed(0);
  }
};
export const numberFormat1 = (number, ratioFixed = 2) => {
  if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
    throw new Error(`${number} or ${ratioFixed} is not a valid number`);
  }
  if (number > 100000000) {
    return number > 0
      ? (number / 100000000).toFixed(ratioFixed)
      : (number / 100000000).toFixed(ratioFixed);
  }
};
/*
  表格数据统一处理
 */
export const tableFormat = (key, val, ratioFixed = 2) => {
  let keyRateArr = [
      "prev_settlement",
      "settlement",
      "px_change",
      "last_px",
      "bid_grp",
      "offer_grp",
      "preclose_px",
      "open_px",
      "high_px",
      "low_px",
      "w52_high_px",
      "w52_low_px"
    ],
    keyAmountArr = [
      "business_amount",
      "business_balance",
      "business_amount_out",
      "amount",
      "amount_delta",
      "entrust_diff",
      "business_amount_in"
    ],
    keyRangeArr = [
      "px_change_rate",
      "min5_chgpct",
      "entrust_rate",
      "turnover_ratio",
      "vol_ratio",
      "amplitude"
    ],
    keyTotalArr = [
      "dyn_pb_rate",
      "pe_rate",
      "circulation_value",
      "market_value"
    ];

  if (keyRateArr.includes(key)) {
    if (key == "px_change") {
      !val || val == "0.0"
        ? (val = (0).toFixed(ratioFixed))
        : (val = Number(val).toFixed(ratioFixed));
    } else {
      !val || val == "0.0"
        ? (val = "--")
        : (val = Number(val).toFixed(ratioFixed));
    }
  } else if (keyRangeArr.includes(key)) {
    val = Number(val).toFixed(2);
  } else if (keyAmountArr.includes(key)) {
    if(["amount", "amount_delta"].includes(key)){
      !val ? (val = "--") : (val = numberFormat(val));
    }else{
      !val ? (val = 0) : (val = numberFormat(val));
    }
  } else if (keyTotalArr.includes(key)) {
    if (key == "dyn_pb_rate" || key == "pe_rate") {
      val ? (val = Number(val).toFixed(2)) : (val = "--");
    } else {
      val ? (val = numberFormat(val)) : (val = "--");
    }
  }
  return val;
};
export const tableFormat1 = (key, val, ratioFixed = 2) => {
  let defaultShowArr = [
      "last_px",
      "bid_grp1",
      "offer_grp1",
      "px_change_rate",
      "px_change",
      "min5_chgpct",
      "business_amount",
      "business_balance",
      "turnover_ratio",
      "amplitude",
      "vol_ratio",
      "entrust_rate",
      "entrust_diff",
      "business_amount_in",
      "bid_grp",
      "offer_grp",
      "preclose_px",
      "prev_settlement",
      "settlement",
      "open_px",
      "high_px",
      "low_px",
      "business_amount_out",
      "w52_high_px",
      "w52_low_px",
      "amount",
      "amount_delta"
    ],
    keyTotalArr = [
      "pe_rate",
      "dyn_pb_rate",
      "circulation_value",
      "market_value"
    ];
  if (defaultShowArr.includes(key)) {
    val = "--";
  } else if (keyTotalArr.includes(key)) {
    if (key == "dyn_pb_rate" || key == "pe_rate") {
      val ? (val = Number(val).toFixed(2)) : (val = "--");
    } else {
      val ? (val = numberFormat(val)) : (val = "--");
    }
  }
  return val;
};

/*债券表格数据统一处理*/
export const bondFormat = (key, val, ratioFixed = 2) => {
  let defaultShowArr = [
      "latest_rate",
      "weighted_average",
      "last_px",
      "high_px",
      "low_px",
      "business_final_px",
      /*债券远期*/
      "pre_final_px",
      "pre_final_ave",
      "open_px_rate",
      "open_px",
      "last_net_price",
      "last_net_rate",
      "high_net_px",
      "low_net_px",
      "high_net_rate",
      "low_net_rate"
    ],
    /*返回值为0类型*/
    returnZeroArr = [
      "px_change_rate",
      "weighted_avg_net_price",
      "weighted_avg_net_rate"
    ],
    keyTotalArr = ["business_amount"];
  if (defaultShowArr.includes(key)) {
    switch (val) {
      default:
        val ? (val = Number(val).toFixed(ratioFixed)) : (val = "--");
        break;
      case 2147.479278:
        val = "--";
        break;
      case 2147479278:
        val = "--";
        break;
      case 0:
        val = "--";
        break;
    }
  } else if (keyTotalArr.includes(key)) {
    switch (val) {
      default:
        val = numberFormat(val);
        break;
      case 2147.479278:
        val = "--";
        break;
      case 2147479278:
        val = "--";
        break;
    }
  } else if (returnZeroArr.includes(key)) {
    val ? (val = Number(val).toFixed(ratioFixed)) : (val = "--");
  }
  return val;
};
/*货币表格数据统一处理*/
export const currencyFormat = (key, val, ratioFixed = 2) => {
  let /*价格类*/
    priceClassArr = [
      /*外汇字段*/
      "fx_last_px",
      "business_term_3M",
      "business_term_6M",
      "open_px",
      "high_px",
      "low_px",
      "best_buy",
      "best_sell",
      "up_px",
      "down_px",
      "lending_last_px",
      "wb_Imply",
      "rmb_rate",
      /*货币字段*/
      /*回购拆借*/
      "weighted_avg",
      "lastest_price",
      /*实时曲线*/
      "to_buy",
      "to_sell",
      "mean_val",
      "last_px",
      /* 中债收益率曲线 */
      'fxterm_description',
      'spread_yield_rate',
    ],
    /*返回值为0类型*/
    returnZeroArr = [
      /*外汇字段*/
      "special_close_px",
      "business_final_px",
      "last_wavg_px"
      /*货币字段*/
    ],
    /*市值类*/
    marketClassArr = [
      /*通用字段*/
      "business_amount",
    ],
    /*日期时间类*/
    datetimeClassArr = ["market_date", "business_last_closedate", "data_timestamp"],
    allowZeroArr = [
      /*shibor利率*/
      "five_days",
      "ten_days",
      "twenty_days",
      "hundred_twenty_days"
    ];

  if (priceClassArr.includes(key)) {
    if (/(^2147|^21.47)(\d|.)+(78$)/.test(val)||val==0) {
      val = "--";
    } else {
      val = Number(val).toFixed(ratioFixed);
    }
  } else if (returnZeroArr.includes(key)) {
    val ? (val = Number(val).toFixed(ratioFixed)) : (val = "--");
  } else if (datetimeClassArr.includes(key)) {
    switch (key) {
      default:
        val ? val : (val = "--");
        break;
    }
  } else if (marketClassArr.includes(key)) {
    if (/(^2147|^21.47)(\d|.)+(78$|00$)/.test(val)||val==0) {
      val = "--";
    } else {
      val = numberFormat1(val);
    }
  } else if (allowZeroArr.includes(key)) {
    if (/(^2147|^21.47)(\d|.)+(78$|00$)/.test(val)) {
      val = "--";
    } else {
      val = Number(val).toFixed(ratioFixed);
    }
  } else {
    return val;
  }

  return val;
};
/**
 * 浮点数据
 */
export const dealFloat = (number1, number12, ratioFixed = 2) => {
  let bigNumber1 = number1 * Math.pow(10, ratioFixed);
  let bigNumber2 = number1 * Math.pow(10, ratioFixed);
  const result = (bigNumber1 - bigNumber2) / Math.pow(10, ratioFixed);
  return result.toFixed(ratioFixed);
};

/**
 * 订阅数据
 */
export const watch = ({ target, key, fn, context, args }) => {
  const property = Object.getOwnPropertyDescriptor(target, key);
  const getter = property && property.get;
  const setter = property && property.set;
  let val = target[key];
  Object.defineProperty(target, key, {
    get: function() {
      const value = getter ? getter.call(target) : val;
      return value;
    },
    set: function(newVal) {
      const value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      fn.apply(context, args);
    }
  });
};

export const hasClass = (ele, className = "") => {
  const classNames = ele.className.split(/\s+/);
  return classNames.some(a => new RegExp("^" + className + "$", "i").test(a));
};
export const addClass = (ele, className = "") => {
  const isHasClass = hasClass(ele, className);
  if (!isHasClass) {
    const classNames = ele.className.split(/\s+/).filter(a => !/^\s*$/.test(a));
    classNames.push(className);
    ele.className = classNames.join(" ");
  }
};
export const removeClass = (ele, className = "") => {
  const isHasClass = hasClass(ele, className);
  if (isHasClass) {
    const classNames = ele.className
      .split(/\s+/)
      .filter(a => !new RegExp("^" + className + "$", "i").test(a));
    ele.className = classNames.join(" ");
  }
};
/**
 * 防抖柯里化
 */
export const curryDebounce = function(fn, context, duration) {
  const args = [].slice.call(arguments, 3);
  let timer = null;
  return function() {
    clearTimeout(timer);
    const finalArgs = [...args, ...[].slice.call(arguments)];
    timer = setTimeout(() => {
      fn.apply(context, finalArgs);
    }, duration);
  };
};
/**
 * 节流
 */
export const curryThrottle = function(fn, context, duration) {
  const args = [].slice.call(arguments, 3);
  let timer = new Date().getTime();
  return function() {
    const nowTime = new Date().getTime();
    if (nowTime - timer > duration) {
      const finalArgs = [...args, ...[].slice.call(arguments)];
      fn.apply(context, finalArgs);
      timer = nowTime;
    }
  };
};
/**
 * object参数函数柯里化
 */
export const curryFun = function(fn, context) {
  const args = [].slice.call(arguments, 2);
  const arg = args.shift();
  return function() {
    const innerArg = [].shift.call(arguments);
    if (!isObject(arg) || !isObject(innerArg)) {
      throw new Error(`arguments is not a object`);
    }
    const finalArg = { ...arg, ...innerArg };
    fn.call(context, finalArg);
  };
};
/* 时间戳格式化 */
export const timestampToTime = function(timestamp) {
  let date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h = date.getHours() + ":";
  let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  let s = date.getSeconds();
  return h + m;
};
/* 时间戳处理 */
export const dateToTime = function(number, ratioFixed = 2) {
  if (number > 10000000) {
    // return (number / 10000000).toFixed(2).replace('.',":").replace('60',"59")
    let pointIdx = String(number / 10000000).indexOf(".");
    const count = Number(String(number / 10000000).slice(0, pointIdx + 3))
      .toFixed(2)
      .replace(".", ":");
    if(count.length === 4){
      return '0' + count
    }else{
      return count
    }
  } else {
    if(!number){
      return '--';
    }
    return number;
  }
};
// 涨跌率格式处理
export const pxChangeFmt = function(compare, px_change, tick_size = 2) {
  if (Number(compare === 0) || /2147479278/.test(compare) || compare == "--") {
    return 0;
  } else {
    return px_change.toFixed(tick_size);
  }
};
// 无效数字
export const getToFixed = function(num, tick_size) {
  if (num == 0 || /2147479278/.test(num)||num==null) {
    return "--";
  } else {
    return num.toFixed(tick_size);
  }
};
export const getDecimal = function (num, pos) {
	  pos = pos ? parseInt(pos) : 0;
	  if (pos <= 0) {
		  return Math.round(num);
	  }
	  num = Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos); //四舍五入
	  num = Number(num).toFixed(pos); //补足位数
	  return Number(num);
};
/**
 *
 */
export const nextTick = (function() {
  if (isDef(process) && isFunction(process.nextTick)) {
    return process.nextTick;
  } else {
    return fn => Promise.resolve().then(fn);
  }
})();

const Util = {
  isNumber,
  isNull,
  isBoolean,
  isString,
  isUndefined,

  isFunction,
  isAsyncFunction,
  isReg,
  isObject,
  isArray,

  isDef,
  isValidNumber,
  isValidArray,
  isValidLengthArray,
  timestampToTime,
  dateToTime,
  getDecimal
};
export default Util;